/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
(function (definition) {
  let $
  const root = ((typeof self === 'object') && (self.self === self) && self) || ((typeof global === 'object') && (global.global === global) && global)

  if (typeof exports === 'object') {
    $ = require('jquery')
    return module.exports = definition(root, $)
  } else {
    ({ $ } = root)
    return root.goTop = definition(root, $)
  }
})((root, $) =>

  function (param) {
    param = param || {}
    param.root = param.root || '.l-goTop'
    param.scrollTop = param.scrollTop || 100

    if (!$(param.root)[0]) { return }

    const obj = {
      ele: $(param.root),
      disp: false,
      dispScrollTop: param.scrollTop
    }

    return $(window).on('scroll', function () {
      if ($(window).scrollTop() > obj.dispScrollTop) {
        if (!obj.disp) {
          obj.ele.animate(
            { opacity: 1 }
            , 400)
          return obj.disp = true
        }
      } else {
        if (obj.disp) {
          obj.ele.animate(
            { opacity: 0 }
            , 400)
          return obj.disp = false
        }
      }
    })
  }
)
